export default { options: { label: 'LaLiga Middleware' } }
